var render = function () {
  var _vm$application, _vm$application2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "page-text--sm grey-9--text line-height-15"
  }, [_vm.application.isOpenHiring ? _c('span', [_vm._v(" 상시채용 " + _vm._s((_vm$application = _vm.application) !== null && _vm$application !== void 0 && _vm$application.closesOnHiring ? "(채용시 마감)" : "") + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.startsAt) + " ~ " + _vm._s(_vm.endsAt) + " " + _vm._s(_vm.daysLeft) + " " + _vm._s((_vm$application2 = _vm.application) !== null && _vm$application2 !== void 0 && _vm$application2.closesOnHiring ? "(채용시 마감)" : "") + " ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }